import { login, logout, getUserInfo } from '@/api/user'
import { setToken, getToken } from '@/libs/util'
import apis from '../../api'
import { Message } from 'iview'

export default {
  state: {
    userName: '',
    userId: '',
    avatorImgPath: '',
    token: getToken(),
    access: [],
    isadmin:0,
    isHoAdmin:false,
    isZoneAdmin:false,
    hasGetInfo: false,
    corp:null
  },
  mutations: {
    setAvator (state, avatorPath) {
      state.avatorImgPath = avatorPath
    },
    setUserId (state, id) {
      state.userId = id
    },
    setIsadmin(state, isadmin){
      state.isadmin = isadmin
    },
    setIsHoAdmin(state, isHoAdmin){
      state.isHoAdmin = isHoAdmin
    },
    setIsZoneAdmin(state, isZoneAdmin){
      state.isZoneAdmin = isZoneAdmin
    },
    setUserName (state, name) {
      state.userName = name
    },
    setAccess (state, access) {
      state.access = access
    },
    setToken (state, token) {
      state.token = token
      setToken(token)
    },
    setHasGetInfo (state, status) {
      state.hasGetInfo = status
    },
    setCorp (state, corp) {
      state.corp = corp
    }
  },
  actions: {
    // 登录
    handleLogin ({ commit }, {corpName,userName, password}) {
        userName = userName.trim();
        corpName = corpName.trim();
        commit('setToken', '');
        commit('setAccess', []);
        commit('setTagNavList',[]);
        return new Promise((resolve, reject) => {
            apis.user.login({
                corpName,
                userName,
                password
            }).then(res => {
                if (res.state == 'ok'){
                    commit('setToken', res.data)
                    resolve()
                }else{
                    Message.error(res.msg);
                    reject(res.msg);
                }
            })
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
        //   commit('setToken', '')
        //   commit('setAccess', [])
        //   resolve()
        // }).catch(err => {
        //   reject(err)
        // })
        // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
        commit('setToken', '');
        commit('setAccess', []);
        commit('setTagNavList',[]);
        resolve()
      })
    },
    // 获取用户相关信息
    getUserInfo ( { commit, dispatch, state, rootState }) {
      return new Promise((resolve, reject) => {
          apis.user.getUserInfo(state.token).then(res => {
              const info = res.data.user
              commit('setAvator', "https://avatars0.githubusercontent.com/u/20942571?s=460&v=4")
              commit('setUserName', info.name)
              commit('setCorp', res.data.corp)
              commit('setUserId', info.id)
              commit('setIsadmin', info.isadmin)
              commit('setIsHoAdmin', res.data.isHoAdmin)
              commit('setIsZoneAdmin', res.data.isZoneAdmin)
              commit('setAccess', res.data.permArray)
              commit('setHasGetInfo', true)
              commit('setZoneList', res.data.zoneList)
              commit('setTeacherList', res.data.teacherList)
              commit('setTimeList', res.data.timeList)
              commit('setCourseList', res.data.courseList)
              commit('setOneToOneCourseList', res.data.oneToOneCourseList)
              commit('setClassCourseList', res.data.classCourseList)
              info.access = res.data.permArray;

              resolve(info)
          }).catch(err => {
              reject(err)
          })
      })
    }
  }
}
